import React, { cloneElement } from "react";

import { Table } from "@devexpress/dx-react-grid-material-ui";
import { TableCell, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  item: {
    padding: `${theme.spacing(0.5)}px !important`,
    width: "100%",
  },
  select: {
    paddingRight: "0 !important",
  },
  details: {
    "& > td": {
      padding: "0 !important",
      textAlign: "center",
    },
  },
}));

export default function Compact({ children }) {
  const classes = useStyles();

  const items = children.filter((child) => !!child.props.tableColumn.column);

  let details = children.find((child) => child.key === "Symbol(detail)");
  if (details) {
    details = cloneElement(details, {
      colSpan: 2,
    });
  }

  let select = children.find((child) => child.key === "Symbol(select)");
  if (select) {
    select = cloneElement(select, {
      className: classes.select,
    });
  }

  return (
    <React.Fragment>
      {select}
      <TableCell
        className={classes.item}
        colSpan={children.length - (select ? 1 : 0)}
      >
        <table>
          <tbody>
            {items.map((item, key) => (
              <tr key={key}>
                <Table.Cell {...item.props}>
                  {item.props.tableColumn.column.title}
                </Table.Cell>
                {item}
              </tr>
            ))}
            {details && <tr className={classes.details}>{details}</tr>}
          </tbody>
        </table>
      </TableCell>
    </React.Fragment>
  );
}
